module.exports = __webpack_public_path__ + "img/type.482b21aa.png";